import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { getTokenSupport } from "utils/AxiosUtil";
import { TokenSupport } from "types/tokenSupport";

/**
 * Whether the backend can actually settle in `token`.
 *
 * The portal decides WHICH tokens to offer; this is the one thing only the deploy knows — whether
 * the address is in the payments contract's registry. Keyed by network + token, at the client's
 * default staleTime: Infinity, since registration changes only via an owner-gated on-chain call.
 *
 * `undefined` while in flight or on error, which callers must read as "unknown", never as "no":
 * an unreachable backend is not evidence that a token is unsupported.
 */
export function useTokenSupport(token: string | undefined) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery<TokenSupport>({
    queryKey: ["tokenSupport", networkType, token],
    queryFn: () => getTokenSupport(token!, networkType),
    enabled: !!user && !!token,
    retry: false,
  });
}
